<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import KeywordPill from "@/components/approval-center/partials/ui/KeywordPill.vue";
import FixPanelSubText from "@/components/approval-center/partials/ui/FixPanelSubText.vue";
import {ref, watch} from 'vue';

const props = defineProps({
  approval: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['open']);
const containerRef = ref(null);
const hasOverflow = ref(false);

const setHasOverflow = () => {
  hasOverflow.value = containerRef.value?.scrollHeight > containerRef.value?.clientHeight;
}

const mutationObserver = new ResizeObserver(() => setHasOverflow());

watch(() => props.approval.approvable.keywords, () => setHasOverflow());

watch(containerRef, () => mutationObserver.observe(containerRef.value));
</script>

<template>
  <div v-if="approval.approvable.keywords && approval.approvable.keywords.length">
    <div class="tw-flex tw-flex-col tw-gap-3">
      <div class="tw-flex tw-justify-between tw-items-center">
        <FixPanelSubText class="tw-font-bold">
          Supporting Keywords:
        </FixPanelSubText>

        <span v-if="hasOverflow">
          <DefaultButton
            class="tw-font-bold !tw-p-0"
            variant="link"
            @click="emit('open')"
          >
            See All Keywords
          </DefaultButton>
        </span>
      </div>

      <div
        ref="containerRef"
        class="tw-flex tw-flex-wrap tw-gap-2 tw-max-h-[84px] tw-overflow-hidden"
      >
        <KeywordPill
          v-for="keyword in approval.approvable.keywords"
          :key="keyword.id"
        >
          {{ keyword.keyword }}
        </KeywordPill>
      </div>
    </div>
  </div>
</template>
